import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom'; // Import Link for navigation
import {
  faTruck,
  faWarehouse,
  faShip,
} from '@fortawesome/free-solid-svg-icons';
import cardImage1 from "../img/logisticsimages/image (6).jpg";
import cardImage2 from "../img/logisticsimages/serivces/image (10) 1.png";
import cardImage3 from "../img/logisticsimages/importandexportimges/image (12).png";

const HoveredCards = ({ image, title, text, icon, iconText, link }) => {
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {
    position: "relative",
    width: "350px",
    height: "320px",
    overflow: "hidden",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
    transition: "transform 0.3s ease",
    transform: isHovered ? "scale(1.05)" : "scale(1)",
  };

  const imageContainerStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    overflow: "hidden",
  };

  const imageStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.5s ease",
    transform: isHovered ? "translateY(-100%)" : "translateY(0)",
  };

  const overlayStyle = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(84 76 76 / 50%)",
    zIndex: 1,
  };

  const contentStyle = {
    position: "absolute",
    bottom: "0",
    width: "100%",
    backgroundColor: "#fac952",
    color: "#fff",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    zIndex: 2,
    opacity: isHovered ? 1 : 0,
    transform: isHovered ? "translateY(0)" : "translateY(100%)",
    transition: "transform 0.5s ease, opacity 0.5s ease",
    marginLeft: "-35px",
    marginTop: "-41px",
    height: "105%",
  };

  const iconTextStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center", 
    justifyContent: "center",
    position: "absolute",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#fac952",
    width: "150%",
    zIndex: 3,
    transition: "transform 0.5s ease",
    transform: isHovered ? "translate(-50%, -150%)" : "translate(-50%, 0)",
  };

  const iconStyle = {
    fontSize: "3rem", // Icon size
    color: "#fac952", // Icon color related 
  };

  const readMoreButtonStyle = {
    backgroundColor: "#000",
    color: "#fff",
    border: "2px solid #000",
    padding: "10px 20px",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "15px",
    borderRadius: "5px",
    transition: "background-color 0.3s",
    opacity: isHovered ? 1 : 0,
    transform: isHovered ? "translateY(0)" : "translateY(100%)",
    transition: "transform 0.5s ease, opacity 0.5s ease",
  };

  return (
    <div
      style={cardStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={imageContainerStyle}>
        <img src={image} alt="Card Background" style={imageStyle} />
        <div style={overlayStyle}></div>
      </div>
      <div style={iconTextStyle}>
        <FontAwesomeIcon icon={icon} style={iconStyle} />
        <span>{iconText}</span>
      </div>
      <div className="content" style={contentStyle}>
        <h2>{title}</h2>
        <p>{text}</p>
        <Link to={link}>
          <button style={readMoreButtonStyle}>
            Read More
          </button>
        </Link>
      </div>
    </div>
  );
};

const CardsContainer = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "50px",
    flexWrap: "wrap",
    marginTop: "20px",
  };

  return (
    <div style={containerStyle}>
      <HoveredCards
        image={cardImage1}
        title="Quick & safe delivery of your goods"
        text="We offer quick and safe delivery in India at very affordable and genuine rates."
        icon={faTruck}
        iconText="Road Transportation"
        link="/it-services"
      />
      <HoveredCards
        image={cardImage2}
        title="Careful storage of your goods"
        text="We offer a door-to-door logistics service to our customers by storing your goods very carefully."
        icon={faWarehouse}
        iconText="Warehousing"
        link="/web-mobile-applications"
      />
      <HoveredCards
        image={cardImage3}
        title="Complex logistics"
        text="We have a systematic approach to the arrangement of life cycle of goods and related activities."
        icon={faShip}
        iconText="Imports & Exports"
        link="/gaming"
      />
    </div>
  );
};

export default CardsContainer;
